import { times } from 'lodash-es';
import { observer } from 'mobx-react';
import React from 'react';

import { Button } from '@mui/material';

import Title from 'pages/Landings/components/Title';
import { useBlogPostsFeed } from 'queries/blog/use-blog-posts-feed';

import PostCard from './components/PostCard';
import PostCardSkeleton from './components/PostCardSkeleton';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Blog: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const blogPostsFeedQuery = useBlogPostsFeed();

    return (
        <section className={cx(classes.root, className)}>
            <Title variant="h2">{'Blog'}</Title>
            <div className={classes.cards}>
                {blogPostsFeedQuery.isLoading
                    ? times(3, (index) => <PostCardSkeleton key={index} />)
                    : blogPostsFeedQuery.data?.map((item, index) => <PostCard key={index} {...item} />)}
            </div>
            <Button
                disableElevation
                disableRipple
                href="https://vulners.com/blog"
                target="_blank"
                variant="contained"
                className={classes.button}
            >
                {'View more articles'}
            </Button>
        </section>
    );
};

export default observer(Blog);
